import styled from 'styled-components';
import { units } from '../../../helpers/styles/units';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${units(12)};
`;
